import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["coachSportItem"];

  connect() {
    console.log("🌏 [coachFormController] connected");
  }

  removeShowcaseAthleteRelationItem(event) {
    event.preventDefault();
    const item = event.target.closest(".coach_sport_item");
    item.remove();
  }
}
